import React from 'react'
import { StyledDiv } from './Section3.style'
import '../../assets/css/section.css'
const Section3 = () => {
  return (
    <StyledDiv>
        <div className="container">
          <div className="row">
            <div className="col-md-12" >
              <div style={{textAlign:'center'}} className='main-swift pt-5 pb-5'>
                <span style={{display:'block'}} className='swift'>Giving Swift Healthcare</span>
                <span style={{display:'block'}} className='swift2'>access to over a Million Kiwis</span>
                <p></p>
              </div>
            </div>
          </div>
        </div>
    </StyledDiv>
  )
}

export default Section3
